import { createFileRoute } from '@tanstack/react-router';
import { StockTakeView } from '../../stock-take/stock-take-view.js';

export const Route = createFileRoute('/_station/stock-take')({
  component: StockTakeView,
});
